import { format } from 'date-fns';
import type { FieldFiltersProps } from './table-data.interfaces';

export const getFilters = (fieldFilters: FieldFiltersProps) => {
  let tmp = '';
  const keys = Object.keys(fieldFilters);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const encodedKey = encodeURIComponent(key);
    const filter = fieldFilters[key];
    const comparison = filter.comparison;
    const value = filter.value;
    const encodedValue = Array.isArray(value)
      ? value.map((v) => encodeURIComponent(v instanceof Date ? format(v, 'yyyy-MM-dd') : String(v))).join(',')
      : encodeURIComponent(value instanceof Date ? format(value, 'yyyy-MM-dd') : String(value));
    if (comparison === 'contains') {
      if (Array.isArray(value)) {
        tmp += `&filter=${encodedKey}:in:${encodedValue}`;
      } else {
        tmp += `&filter=${encodedKey}:like:${encodedValue}`;
      }
    } else if (comparison === '=') {
      tmp += `&filter=${encodedKey}:eq:${encodedValue}`;
    } else if (comparison === '<=') {
      tmp += `&filter=${encodedKey}:lte:${encodedValue}`;
    } else if (comparison === '>=') {
      tmp += `&filter=${encodedKey}:gte:${encodedValue}`;
    } else if (comparison === 'between' && Array.isArray(value)) {
      if (value[0] instanceof Date && value[1] instanceof Date) {
        const from = format(value[0], 'yyyy-MM-dd');
        const to = format(value[1], 'yyyy-MM-dd');
        tmp += `&filter=${encodedKey}:gte:${from}&filter=${encodedKey}:lte:${to}`;
      } else {
        tmp += `&filter=${encodedKey}:gte:${value[0]}&filter=${encodedKey}:lte:${value[1]}`;
      }
    }
  }

  return tmp;
};
